/**
 * @desc 分页
 */
const URL = "/rantion-device";
import http, { updateResponse } from "@/http";
export type Response = defs.device.ResponseDto<
  defs.device.IPage<defs.device.SkuFirmwareResponseDto>
>;
export function request(
  params: API.device.skuFirmware.page.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/skuFirmware/page`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
